module.exports = __webpack_public_path__ + "img/aide-soignant-f.d15dc266.jpg";